import { deserializeEditorHTML, serializeEditorHTML } from "@/tiptap/core/editor-serialization"
import {
  handleClipboardImagePaste,
  handleImageSelectionCopy,
  sanitizeEditorClipboardHTML,
} from "@/tiptap/core/editor-clipboard"
import { buildEditorExtensions } from "@/tiptap/core/editor-extensions"

export function createEditorConfig({
  content,
  placeholder = "Start writing...",
  onChange,
  onTocUpdate,
  imageUpload,
  tableOptions,
  editorClassName = "notion-like-editor",
} = {}) {
  return {
    content: deserializeEditorHTML(content),
    editorProps: {
      attributes: {
        class: editorClassName,
      },
      handleDOMEvents: {
        copy: (view, event) => handleImageSelectionCopy(view, event),
        cut: (view, event) => handleImageSelectionCopy(view, event, { cut: true }),
      },
      handlePaste: (view, event) =>
        handleClipboardImagePaste(view, event, { imageUpload }),
      transformPastedHTML: (html) => sanitizeEditorClipboardHTML(html),
      // On touch devices, ProseMirror's default scroll-to-selection jumps the
      // page to a distant caret when focusing/updating (accordion, images, etc.).
      // TipTap's focus() on iOS/Android still calls view.dom.focus() without
      // preventScroll — Turn into / toolbar actions use runWithPreservedWindowScroll.
      // Intentional scrolls (find, TOC) use element.scrollIntoView directly.
      handleScrollToSelection: () =>
        typeof window !== "undefined" &&
        window.matchMedia("(pointer: coarse)").matches,
    },
    onUpdate: ({ editor }) => {
      onChange?.(serializeEditorHTML(editor))
    },
    extensions: buildEditorExtensions({
      placeholder,
      onTocUpdate,
      imageUpload,
      tableOptions,
    }),
  }
}

export default createEditorConfig
